import React from 'react';
import { ExternalLink, Megaphone } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const AnnouncementCard = ({ announcement }) => {
  if (!announcement) return null;

  return (
    <Card className="border-l-4 border-l-mint-500 bg-gradient-to-r from-mint-50 to-white">
      <CardContent className="p-4">
        <div className="flex gap-4">
          {/* Icon or Image */}
          <div className="flex-shrink-0">
            {announcement.imageUrl ? (
              <img
                src={announcement.imageUrl}
                alt=""
                className="w-16 h-16 rounded-lg object-cover"
              />
            ) : (
              <div className="w-12 h-12 bg-mint-100 rounded-lg flex items-center justify-center">
                <Megaphone className="w-6 h-6 text-mint-600" />
              </div>
            )}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-gray-900 mb-1">
              {announcement.title}
            </h3>
            <p className="text-sm text-gray-600 line-clamp-2 mb-2">
              {announcement.content}
            </p>
            {announcement.linkUrl && (
              <a
                href={announcement.linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 text-sm font-medium text-mint-600 hover:text-mint-700"
              >
                {announcement.linkText || 'Learn More'}
                <ExternalLink className="w-3 h-3" />
              </a>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AnnouncementCard;
